import React, { useEffect, useState } from "react"
import API from '../Common/API'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { setLoggedIn, setMenuItems, setToken, setUserDetails, setAccountType, setEducationList, setFullEducations, setZodiacSigns, setFlaws, setTFlaws, setStatus, setTStatus, setOccupation, setTOccupation, setFullOccupation, setDhisa, setAllStars, setTDhisa } from '../Store/Auth/actions'
import Alert from '../Components/Alerts'
import { setAlert, setLanguage } from '../Store/Theme/actions'
import HomeRoot from "./HomeRoot";
import Login from "../Pages/Auth/Login";
import Loaders from "../Components/Loaders/Loaders";
import axios from "axios";


const Root = () => {

    const [loading, setLoading] = useState(false)
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
    const dispatch = useDispatch();
    const [isLoggedChecked, setIsLoggedChecked] = useState(false);
    const setHideAlert = () => dispatch(setAlert({ active: false }));
    const alert = useSelector((state) => state.theme.alert)
    const [routes, setRoutes] = useState()
    const accountType = localStorage.getItem('accountType')

    useEffect(() => {
        // adding interceptors to api
        API.interceptors.request.use((request) => {
            setLoading(true);
            // dispatch(setLoading(true))
            return request;
        });
        API.interceptors.response.use(
            (response) => {
                setLoading(false);
                // dispatch(setLoading(false))
                return response;
            },
            (error) => {
                setLoading(false);
                // dispatch(setLoading(false))
                return Promise.reject(error);
            }
        );
    }, []); // eslint-disable-line

    const checkLoggedIn = () => {
        let lang = localStorage.getItem('i18nextLng')
        lang !== 'null' ? dispatch(setLanguage(lang)) : dispatch(setLanguage('en'))
        let token = localStorage.getItem('token')
        if (!token && isLoggedIn) {
            dispatch(setLoggedIn(false));
        } else if (token && token.split(".").length > 1) {
            let userDetails = JSON.parse(atob(token.split(".")[1]));
            setIsLoggedChecked(true);
            dispatch(setLoggedIn(true))
            dispatch(setToken(token))
            dispatch(setMenuItems(JSON.parse(localStorage.getItem('menuItems'))))
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            dispatch(setAccountType(accountType))
            dispatch(setUserDetails(userDetails))
        } else {
            setIsLoggedChecked(true)
        }
        axios.all([API.get('/common/getEducations'), API.get('/common/getZodiacSign'), API.get('/common/getAllFlaws'), API.get('/common/getStatusList'), API.get('/common/getOccupations'), API.get('/common/getAllStars'), API.get('/common/getDhisa')]).then((axios.spread((eduRes, zodiacRes, flawRes, statRes, occuRes, starRes, dhisaRes) => {
            dispatch(setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} - ${c.specialization}`, value: c._id } })))
            dispatch(setFullEducations(eduRes.data.data))
            dispatch(setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } })))
            dispatch(setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } })))
            dispatch(setTFlaws(flawRes.data.data.map((c) => { return { text: c.tFlawName, value: c._id } })))
            dispatch(setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } })))
            dispatch(setTStatus(statRes.data.data.map((c) => { return { text: c.tStatus, value: c._id } })))
            dispatch(setOccupation(occuRes.data.data.map((c) => { return { text: c.occupation, value: c._id } })))
            dispatch(setTOccupation((occuRes.data.data.map((c) => { return { text: c.tOccupation, value: c._id } }))))
            dispatch(setFullOccupation(occuRes.data.data))
            dispatch(setDhisa(dhisaRes.data.data.map((c) => { return { text: c.dhisa, value: c.dhisaId } })));
            dispatch(setTDhisa(dhisaRes.data.data.map((c) => { return { text: c.tDhisa, value: c.dhisaId } })))
            dispatch(setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } })))
        })))
    }



    useEffect(() => {
        setIsLoggedChecked(false)
        checkLoggedIn()
    }, [isLoggedIn])

    useEffect(() => {
        if (isLoggedIn) {
            setRoutes(
                <Switch>
                    <Route path="/" component={HomeRoot} />
                    <Redirect to="/" />
                </Switch>
            )
        } else {
            setRoutes(
                <Switch>
                    <Route path="/auth/login" component={Login} />
                    <Route path="/" component={Login} />
                </Switch>
            )
        }
    }, [isLoggedIn])

    return (
        <>
            {isLoggedChecked ? <div className="h-100">
                <Alert title={alert.title} subtitle={alert.subtitle} active={alert.active} setActive={setHideAlert} type={alert.type} />
                {routes}
            </div> : <Loaders />}
        </>
    )
}

export default Root